'use strict';

var util = angular.module('gymsystem.util');

util.directive('allactivities', ['$rootScope', '$modal', '$filter', 'server', 'live', 'util', function($rootScope, $modal, $filter, server, live, util) {
    return {
        restrict: 'E',
        template: '<customertable config="config" />',
        scope: {
            settings: '='
        },
        link: function($scope) {
            function getMinAndMaxAge(activity) {
                var bookings = activity.bookings;
                var ages = _.map(bookings, function(b) {
                    var booker = $rootScope.getMember(b.user_id);
                    return util.getAgeFromPersonalCodeNumber(booker.personalCodeNumber);
                });
                if (ages.length < 1) { return ''; }
                return _.min(ages) + ' - ' + _.max(ages) + ' ' + $filter('translate')('years old');
            }

            function getNumOfBooked(activity) {
                var numBooked = activity.numBooked;
                var space = activity.space;
                var numBookedStr = '';
                return (numBooked + (space ? ' ' + $filter('translate')('of') + ' ' + space : '')) + numBookedStr;
            }

            function getInstructor(activity) {
                var instructors = activity.staffs;
                if (instructors.length > 0) {
                    return instructors[0].firstname + ' ' + instructors[0].lastname + (instructors.length > 1 ? ' + ' + (instructors.length - 1) : '');
                } else {
                    return '';
                }
            }

            function orderShortDate(a, b) {
                var aval = a.start;
                var bval = b.start;
                return aval < bval ? -1: (aval > bval ? 1 : 0);
            }

            var all_columns = [
                {field: 'startDate', title: 'Date', getValue: function(activity) { return util.getShortDate(activity.startTime); }, compare: orderShortDate},
                {field: 'startTime', title: 'Time', getValue: function(activity) { return util.getShortTimePeriod(activity); }},
                {field: 'workoutType.name', title: 'Activity'},
                {field: 'numBooked', title: 'Number of booked', getValue: function(activity) { return getNumOfBooked(activity); }},
                {field: 'age', title: 'Age range', getValue: function(activity) { return getMinAndMaxAge(activity); }},
                {field: 'instructor', title: 'Instructor', getValue: function(activity) { return getInstructor(activity); }}
            ];

            var columns = $scope.settings.columns.map(function(column_id) {
                return _.findWhere(all_columns, {field: column_id});
            });

            $scope.add = function(workout) {
                $modal.open({
                    templateUrl: 'views/bookingadd.html',
                    controller: 'WorkoutBookingAddModalCtrl',
                    windowClass: 'huge-modal-window',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
            };

            $scope.invite = function(workout) {
                server.get('/api/workoutBooking/invites/get', {workout_id: workout.id}).then(function(invites) {
                    invites.forEach($rootScope.transformInvitation);
                    workout.bookings.forEach($rootScope.transformWorkoutBooking);
                    $modal.open({
                        templateUrl: 'views/addmodal.html',
                        controller: 'InviteAddModalCtrl',
                        resolve: {
                            workout: function() {
                                return workout;
                            },
                            invites: function() {
                                return invites;
                            }
                        }
                    });
                });
            };

            $scope.sendMailing = function(workout) {
                var receivers = workout.bookings.map(function(wb) { return $rootScope.getMember(wb.user_id); });
                $scope.pubsub.publish('newmailingdata', {
                    isNewsOrAdvertising: false,
                    sendOption: 'mail',
                    receivers: receivers,
                    options: { 'callCloseOnSuccess': true, 'modalMode': true }
                });
                $modal.open({
                    templateUrl: 'views/mailingnew.html',
                    windowClass: 'huge-modal-window',
                    controller: 'NewMailingCtrl'
                });
            };

            $scope.cancel = function(workout) {
                $modal.open({
                    templateUrl: 'views/cancelworkout.html',
                    controller: 'CancelWorkoutCtrl',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
            };

            var start = new Date();
            var day = start.clone().getDay();
            var duration = $scope.settings.weeks * 7 + (7 - (day === 0 ? 7 : day));
            var end = $scope.settings.onlyShowToday ? start.clone() : start.clone().addDays(duration);
            function getResourceAllocations() {
                $scope.activities = [];
                server.post2('/api/schedule/workout/get/all', {fromDate: start.yyyymmdd(), toDate: end.yyyymmdd(), bookings: true}).then(function(response) {
                    $scope.activities = response;
                });
            }
            getResourceAllocations();

            $scope.activityButtonsConfig = {
                title: 'Shortcuts',
                inline: true,
                alignRight: true,
                buttonClass: function() { return 'btn-primary'; },
                actions: [
                    {title: 'Show', onClick: function(activity) { $rootScope.showWorkout(activity); } },
                    {title: 'Add booking', visible: function(activity) { return $rootScope.canAddBooking(activity); }, onClick: function(activity) { $scope.add(activity); }},
                    {title: 'Invite via mail', visible: function() { return $rootScope.hasPermission('Checkout handling'); }, onClick: function(activity) { $scope.invite(activity); }},
                    {title: 'Send mailing to bookings', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.sendMailing(activity); }},
                    {title: 'Cancel workout', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.cancel(activity); }}
                ]
            };

            var buttons = [
                {title: 'Show', buttonClass: 'btn-success', onClick: function(activity) { $rootScope.showWorkout(activity); }},
                {title: 'Add booking', buttonClass: 'btn-success', visible: function(activity) { return $rootScope.canAddBooking(activity); }, onClick: function(activity) { $scope.add(activity); }},
                {title: 'Invite via mail', buttonClass: 'btn-success', visible: function() { return $rootScope.hasPermission('Checkout handling'); }, onClick: function(activity) { $scope.invite(activity); }},
                {title: 'Send mailing to bookings', buttonClass: 'btn-primary', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.sendMailing(activity); }},
                {title: 'Cancel workout', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Send mail'); }, onClick: function(activity) { $scope.cancel(activity); }}
            ];

            var isMobile = $rootScope.isMobile && $rootScope.isMobile();
            $scope.config = {
                getItems: function() { return $scope.activities; },
                hideSearch: true,
                itemFilter: function(activity) {
                    // If category is empty or undefined, show all activitys
                    if (!$scope.settings.category || $scope.settings.category.length === 0) {
                        return true;
                    }
                    return $scope.settings.category.indexOf(activity.workoutType.category_id) > -1;
                },
                columns: columns,
                orderColumn: $scope.settings.onlyShowToday ? 'startTime' : 'startDate',
                tableLimit: 10,
                tableOverflow: 'unset',
                renderHtmlMobile: isMobile,
                numOfVisibleColumns: 3
            };

            if (isMobile) {
                $scope.config.buttons = buttons;
            } else {
                $scope.config.multibutton = $scope.activityButtonsConfig;
            }

            live.subscribe({
                type: 'workout',
                scope: $scope,
                callback: function() {
                    getResourceAllocations();
                }
            });

            live.subscribe({
                type: 'workoutbooking',
                scope: $scope,
                callback: function() {
                    getResourceAllocations();
                }
            });
        }
    };
}]);
